(function () {
  'use strict';

  angular.module('app').component('providerDetail', providerDetail());

  function providerDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        fast: '<',
        hideTopControls: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
        isModal: '<',
      },
      controller: ProviderDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/providers/provider-detail/provider-detail.component.html',
    };
  }

  ProviderDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'ProviderService',
    'ProviderTypeService',
    'LanguageService',
    'SessionService',
    'CreditPaymentTermService',
    '$location',

    // Angular downgraded service
    'countryService',
    'companyService',
    'currencyService',
  ];

  function ProviderDetailComponent(
    config,
    UtilService,
    ProviderService,
    ProviderTypeService,
    LanguageService,
    SessionService,
    CreditPaymentTermService,
    $location,

    // Angular downgraded service
    countryService,
    companyService,
    currencyService
  ) {
    // public properties
    // -----------------------
    const vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.activeStatus = config.ACTIVE;
    vm.inactiveStatus = config.INACTIVE;

    // private properties
    // -----------------------
    let cropedImage = { file: null };

    let companyId = SessionService.getSelectedAccountCompany().id;
    let userLanguageCode = SessionService.getUserLanguage().code;

    vm.$onInit = function () {
      vm.showFormField = true;

      if (vm.fast) {
        vm.showFormField = false;
      }

      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
        getTaxIdTypesByCountry(vm.item.country);
      } else {
        vm.createMode = true;

        vm.item = {
          credit_enabled: false,
          social_profiles: [],
          prepayment_ranges: [],
          is_client: false,
        };

        vm.stateLabel = 'STATE';
        vm.cityLabel = 'CITY';

        vm.labelAddLogo = 'ADD_PHOTO';

        // Initializers
        getCountries();
        getProviderTypes();

        getLanguages();
      }

      // Initializers
      getCompany();
    };

    // public methods
    // -----------------------
    vm.selectAssociatedProducts = function () {
      vm.showAssociatedProducts = true;

      getLanguages(); // In case the edit mode is not selected at first load
    };

    vm.selectCountry = function (country) {
      if (vm.countrySelected && vm.countrySelected.id === country.id) {
        // Same country is selected
        return;
      }

      vm.countrySelected = country;

      vm.item.tax_id_code = null;
      vm.item.tax_id_number = null;

      vm.item.state_id = null;
      vm.item.city_id = null;
      vm.item.district_id = null;

      vm.taxIdType = null;

      vm.item.last_name = null;
      vm.showLastName = true;
      vm.lastNameRequired = false;

      if (!vm.item.phone_number) {
        vm.selectCountryPhone(country);
        vm.item.phone_code = country.phone_code;
      }

      getTaxIdTypesByCountry(country);
      setCountryStatesLabels(country);
      getCountryStates(country);
    };

    vm.selectTaxIdType = function (taxIdType) {
      vm.item.legal_id = null;

      vm.taxIdType = taxIdType;

      setLastNameRequired(taxIdType.code);
    };

    vm.selectProviderType = function (provider_type) {
      vm.providerTypeIsBusiness = provider_type.is_business;
    };

    vm.selectState = function (state_id) {
      vm.item.city_id = null;
      vm.item.district_id = null;

      getCitiesByState(state_id);
    };

    vm.selectCity = function (city_id) {
      vm.item.district_id = null;
      getDistrictsByCity(city_id);
    };

    vm.selectCountryPhone = function (country) {
      vm.countryPhoneSelected = country;
    };

    vm.selectCountrySecondaryPhone = function (country) {
      vm.countrySecondaryPhoneSelected = country;
    };

    vm.selectCountryMobile = function (country) {
      vm.countryMobileSelected = country;
    };

    vm.selectCountryFax = function (country) {
      vm.countryFaxSelected = country;
    };

    vm.openProviderTypesModal = function () {
      let successCallback = function () {
        vm.providerTypes = null;
        getProviderTypes();
      };

      ProviderTypeService.openProviderTypesModal(successCallback);
    };

    vm.addSocialProfile = function () {
      vm.item.social_profiles.push({
        createMode: true,
      });
    };

    vm.removeSocialProfile = function (index) {
      vm.item.social_profiles.splice(index, 1);
    };

    vm.changeSocialProfileStatus = function (item) {
      item.status = item.status === vm.activeStatus ? vm.inactiveStatus : vm.activeStatus;
    };

    vm.addPrepaymentRange = function () {
      vm.item.prepayment_ranges.push({
        createMode: true,
      });

      vm.validateUniquePrepaymentRanges();
    };

    vm.removePrepaymentRange = function (index) {
      vm.item.prepayment_ranges.splice(index, 1);
      vm.validateUniquePrepaymentRanges();
    };

    vm.changePrepaymentRangeStatus = function (item) {
      item.status = item.status === vm.activeStatus ? vm.inactiveStatus : vm.activeStatus;
    };

    // Avoid duplicate prepayment ranges
    vm.validateUniquePrepaymentRanges = function () {
      vm.prepaymentRangesDuplicated = false;

      let prepaymentRanges = vm.item.prepayment_ranges;
      if (prepaymentRanges.length > 1) {
        for (let i = 0; i < prepaymentRanges.length; ++i) {
          for (let j = 0; j < prepaymentRanges.length; ++j) {
            if (
              i !== j &&
              prepaymentRanges[i].start_day &&
              prepaymentRanges[i].start_day === prepaymentRanges[j].start_day &&
              prepaymentRanges[i].end_day === prepaymentRanges[j].end_day
            ) {
              vm.prepaymentRangesDuplicated = true;
              return false;
            }
          }
        }
        return true;
      }
    };

    vm.openCreditPaymentTermsModal = function () {
      let successCallback = function () {
        CreditPaymentTermService.getCreditPaymentTerms({ skip_check_role: true }).then(function (
          data
        ) {
          vm.company.credit_payment_terms = data;
        });
      };

      CreditPaymentTermService.openCreditPaymentTermsModal(
        vm.company.credit_payment_terms,
        companyId,
        successCallback
      );
    };

    vm.editProvider = function () {
      vm.editMode = true;
      vm.viewMode = false;

      // Initializers
      getCountries();
      getProviderTypes();

      getLanguages();

      setCountryStatesLabels(vm.item.country);
      getCountryStates(vm.item.country);
    };

    vm.cancelEdit = function () {
      // If we cancel the edition when changing country
      if (vm.originalItem.country_id !== vm.item.country_id) {
        getTaxIdTypesByCountry(vm.originalItem.country);
      }

      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    };

    vm.openLogo = function () {
      let logoSaved = (cropedImageObj) => {
        cropedImage = cropedImageObj;

        if (vm.editMode) {
          ProviderService.updateLogo(vm.item, cropedImage);
        } else {
          var img = document.getElementById('logo-image-preview'); // <HTMLInputElement>
          img.src = URL.createObjectURL(cropedImage.file);
        }
      };

      ProviderService.openLogo(vm.item, logoSaved);
    };

    vm.deleteLogo = function () {
      vm.item.logo = null;
      vm.item.logoUrl = null;
      ProviderService.deleteLogo(vm.item);
    };

    // Create/Update
    vm.saveProvider = function (isFormValid) {
      vm.formErrors = false;

      let to = vm.isModal ? 'providers' : '';

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop(to);

        return;
      }

      // Do not send relations
      let item = angular.copy(vm.item);

      delete item.provider_type;
      delete item.country;
      delete item.associated_banks;
      delete item.provider_contacts;

      if (!vm.showLastName) {
        item.last_name = ''; // Reset last_name if doest not apply
      }

      createProvider(item, cropedImage, to);
    };

    vm.cancel = function () {
      /*if (vm.editMode){
                vm.cancelEdit();
                return;
            }*/

      vm.onCanceledItem({ item: vm.item });
    };

    vm.onShowClient = function (id) {
      $location.path(`/clients/${id}`);
    };

    vm.onAssociatedProductSaved = function (items) {
      vm.originalItem.associated_products = items;
    };

    vm.onAssociatedProductDeleted = function (items) {
      vm.originalItem.associated_products = items;
    };

    vm.onAssociatedBankSaved = function (items) {
      vm.originalItem.associated_banks = items;
    };

    vm.onAssociatedBankDeleted = function (items) {
      vm.originalItem.associated_banks = items;
    };

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editMode = true;

        vm.editProvider();
      }

      vm.providerTypeIsBusiness = (item.provider_type && item.provider_type.is_business) || false;

      vm.countrySelected = item.country;
      if (vm.countrySelected) {
        setCountryStatesLabels(vm.countrySelected);
      }

      vm.item.is_client = vm.item.is_client === undefined ? false : vm.item.is_client;

      vm.item.social_profiles = item.social_profiles || [];
      vm.item.prepayment_ranges = item.prepayment_ranges || [];
      // vm.item.credit_payment_terms = item.credit_payment_terms || [];

      // vm.item.purchase_conditions  = item.purchase_conditions || [];

      vm.itemName = item.name;
      if (item.last_name && vm.showLastName) {
        vm.itemName += ' ' + item.last_name;
      }

      vm.labelAddLogo = item.logo.url ? 'CHANGE_PHOTO' : 'ADD_PHOTO';

      vm.originalItem = angular.copy(item); // store server data
    }

    function getCompany() {
      vm.loadingCompany = true;
      companyService
        .getCompany(companyId, { skip_check_role: true, lang: userLanguageCode })
        .subscribe((response) => {
          vm.company = response;

          vm.atvCrEnabled =
            vm.company.company_integration && vm.company.company_integration.atv_cr_enabled
              ? true
              : false;

          if (vm.viewMode && vm.item.default_credit_payment_term_id) {
            vm.creditPaymentTerm = vm.UtilService.findItemInArray(
              vm.company.credit_payment_terms,
              'id',
              vm.item.default_credit_payment_term_id
            );
          }

          getCurrencies(vm.company.currency_ids);

          vm.loadingCompany = false;
        });
    }

    function getCurrencies(companyCurrencyIds) {
      vm.currentExchangeExist = true;

      let params = {
        get: 'per_company',
        'currency_ids[]': companyCurrencyIds,
        skip_check_role: true,
      };

      vm.loadingCurrenciesPerCompany = true;
      currencyService.getCurrencies({ get: 'active' }).subscribe((response) => {
        vm.currenciesPerCompany = response;

        vm.loadingCurrenciesPerCompany = false;
      });
    }

    function getCountries() {
      if (vm.countries) return;

      vm.loadingCountries = true;
      countryService
        .getCountries({ get: 'active', skip_check_role: true })
        .subscribe((response) => {
          vm.countries = response;

          if (!vm.createMode && vm.item.phone_code) {
            let countryPhone = vm.UtilService.findItemInArray(
              vm.countries,
              'phone_code',
              vm.item.phone_code
            );

            vm.selectCountryPhone(countryPhone);
          }

          vm.loadingCountries = false;
        });
    }

    function getStatesByCountry() {
      let params = {
        get: 'active',
        skip_check_role: true,
      };

      countryService.getStates(vm.item.country_id, params).subscribe((response) => {
        vm.statesByCountry = response;
      });
    }

    function getCitiesByState(state_id) {
      let params = {
        get: 'active',
        by_state: state_id,
        skip_check_role: true,
      };

      countryService.getCities(vm.item.country_id, params).subscribe((response) => {
        vm.citiesByState = response;
      });
    }

    function getDistrictsByCity(city_id) {
      let params = {
        get: 'active',
        by_city: city_id,
        skip_check_role: true,
      };

      countryService.getDistricts(vm.item.country_id, params).subscribe((response) => {
        vm.districtsByCity = response;
      });
    }

    function getProviderTypes() {
      if (vm.providerTypes) return;

      vm.loadingProviderTypes = true;
      ProviderTypeService.getProviderTypes({ get: 'active', skip_check_role: true }).then(function (
        data
      ) {
        vm.providerTypes = data.items;

        vm.loadingProviderTypes = false;
      });
    }

    function getLanguages() {
      if (vm.languages) return;

      LanguageService.getLanguages({ get: 'active', skip_check_role: true }).then(function (data) {
        vm.languages = data.items;

        vm.defaultLanguage = vm.languages.filter((language) => language.is_default)[0].lang;
      });
    }

    function setCountryStatesLabels(country) {
      vm.stateLabel = 'STATE';
      vm.cityLabel = 'CITY';

      if (country.enable_states) {
        vm.stateLabel = 'PROVINCE';
        vm.cityLabel = 'CANTON';
      }
    }

    function getCountryStates(country) {
      if (country.enable_states) {
        getStatesByCountry();

        if (vm.item.state_id) {
          getCitiesByState(vm.item.state_id);
        }

        if (vm.item.city_id) {
          getDistrictsByCity(vm.item.city_id);
        }
      }
    }

    function getTaxIdTypesByCountry(country) {
      // TODO: what about the rest of the countries?
      // if (country.code !== 'CR'){
      //     return;
      // }

      let params = {
        country_code: country.code,
        skip_check_role: true,
        lang: userLanguageCode,
      };

      vm.loadingTaxIdTypes = true;
      countryService.getTaxIdTypesByCountry(params).subscribe((response) => {
        vm.taxIdTypesByCountry = response;

        vm.taxIdType = vm.UtilService.findItemInArray(response, 'code', vm.item.tax_id_code);

        setLastNameRequired(vm.item.tax_id_code);

        vm.loadingTaxIdTypes = false;
      });
    }

    function setLastNameRequired(taxIdCode) {
      if (taxIdCode === '02') {
        // company type
        vm.showLastName = false;
        vm.lastNameRequired = false;
      } else {
        vm.showLastName = true;
        vm.lastNameRequired = true;
      }
    }

    function createProvider(item, cropedImage, to) {
      vm.sendingForm = true;
      ProviderService.saveProvider(item, cropedImage).then(
        function (response) {
          let data = response.data;

          if (!vm.editMode) {
            // Create
            vm.onSavedItem({ item: data });
          } else {
            // Edit
            vm.item = data;
            vm.item.logoUrl = data.logo.url;
            setItemOptions(data);

            if (data.default_credit_payment_term_id) {
              vm.creditPaymentTerm = vm.UtilService.findItemInArray(
                vm.company.credit_payment_terms,
                'id',
                data.default_credit_payment_term_id
              );
            }

            vm.UtilService.scrollToTop(to);
          }

          vm.sendingForm = false;
        },
        function (response) {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.data.errors);

          vm.formErrors = true;
          vm.UtilService.scrollToTop(to);

          vm.sendingForm = false;
        }
      );
    }
  }
})();
